class TabController {
  constructor(container) {
    this.container = document.querySelector(container);
    this.tablist = this.container.querySelector('[role=tablist]');
    this.tabs = this.container.querySelectorAll('[role=tab]');
    this.tabpanels = this.container.querySelectorAll('[role=tabpanel]');
    this.activeTab = this.container.querySelector('[role=tab][aria-selected=true]');
    this.supportUrls = this.container.querySelectorAll('.access-support');
    this.addEventListeners();
  }

  // Private function to set event listeners
  addEventListeners() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        this.setActiveTab(tab.getAttribute('aria-controls'));
      });
      tab.addEventListener('keyup', (e) => {
        if (e.keyCode === 13 || e.keyCode === 32) { // return or space
          e.preventDefault();
          this.setActiveTab(tab.getAttribute('aria-controls'));
        }
      });
    });
    this.tablist.addEventListener('keyup', (e) => {
      switch (e.keyCode) {
        case 35: // end key
          e.preventDefault();
          this.setActiveTab(this.tabs[this.tabs.length - 1].getAttribute('aria-controls'));
          break;
        case 36: // home key
          e.preventDefault();
          this.setActiveTab(this.tabs[0].getAttribute('aria-controls'));
          break;
        case 37: // left arrow
          e.preventDefault();
          // eslint-disable-next-line
          let previous = [...this.tabs].indexOf(this.activeTab) - 1;
          previous = previous >= 0 ? previous : this.tabs.length - 1;
          this.setActiveTab(this.tabs[previous].getAttribute('aria-controls'));
          break;
        case 39: // right arrow
          e.preventDefault();
          // eslint-disable-next-line
          let next = [...this.tabs].indexOf(this.activeTab) + 1;
          next = next < this.tabs.length ? next : 0;
          this.setActiveTab(this.tabs[next].getAttribute('aria-controls'));
          break;
        default:
          break;
      }
    });
    this.supportUrls.forEach((support) => {
      support.addEventListener('click', (e) => {
        e.preventDefault();
        //  force to reload page
        window.location.href = e.target.href;
        window.location.reload();
      });
    });
  }

  // Public function to set the tab by id
  // This can be called by the developer too.
  setActiveTab(id) {
    this.tabs.forEach((tab) => {
      if (tab.getAttribute('aria-controls') === id) {
        tab.setAttribute('aria-selected', 'true');
        tab.focus();
        this.activeTab = tab;
      } else {
        tab.setAttribute('aria-selected', 'false');
      }
    });

    this.tabpanels.forEach((tabpanel) => {
      if (tabpanel.getAttribute('id') === id) {
        tabpanel.setAttribute('aria-expanded', 'true');
      } else {
        tabpanel.setAttribute('aria-expanded', 'false');
      }
    });
  }
}

const tabs = document.getElementById('tab-settings');
if (tabs) {
  const tabController = new TabController('#tab-settings');
  const urlHash = window.location.toString().split('#')[1];
  const id = urlHash && Array.isArray(urlHash.split('&')) && urlHash.split('&').length ? urlHash.split('&')[0] : urlHash;

  if (id) {
    tabController.setActiveTab(id);
  }
}
